import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import OtpVerification from "./components/OtpVerification";
import MainApp from "./MainApp";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path={"/log-in"} element={<Login />} />
        <Route path={"/otp-verification"} element={<OtpVerification />} />
        <Route exact path="/*" element={<MainApp />} />
      </Routes>
    </div>
  );
}

export default App;
